import { render, staticRenderFns } from "./Extract.vue?vue&type=template&id=1608fe80&scoped=true"
import script from "./Extract.vue?vue&type=script&lang=js"
export * from "./Extract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1608fe80",
  null
  
)

export default component.exports